export default [
    {
        'rule' : 'Sponsored For Employee For A Particular Gender',
        'name' : '',
        'gender' : 1,
        'age' : 0,
        grade : 0,
    },
    {
        'rule'  : 'Sponsored For Employee For A Particular Age',
        'name' : '',
        'gender' : 0,
        age : 1,
        grade: 0,
    },
    {
        'rule'  : 'Sponsored For Employee For A Particular Age And Gender',
        'name' : '',
        'gender' : 1,
        age : 1,
        grade : 0
    },
    {
        'rule'  : 'Sponsored For Employee For A Particular Grade',
        'name' : '',
        'gender' : 0,
        age : 0,
        grade : 1
    },
    {
        'rule'  : 'Sponsored For Employee For A Particular Gender And Grade',
        'name' : '',
        'gender' : 1,
        grade : 1,
        age : 0
    },
    {
        'rule'  : 'Sponsored For Employee For A Particular Age, Gender And Grade',
        'name' : '',
        'gender' : 1,
        age : 1,
        grade : 1
    },
    {
        'rule'  : 'Sponsored For Employee And Spouse For A Particular Grade And Gender',
        'name' : '',
        'gender' : 1,
        grade : 1,
        age : 0
    },
    {
        'rule'  :  'Sponsored For Employee And Beneficiaries Are Sponsored Once',
        'name' : '',
        'gender' : 0,
        grade : 0,
        age : 0
    },
    {
        'rule'  :  'Sponsored For Employee And Beneficaires Are Sponsored For A Particular Gender',
        'name' : '',
        'gender' : 1,
        grade : 0,
        age : 0
    },
    {
        'rule'  :  'Sponsored For Employee And Beneficaires Are Sponsored For A Particular Gender',
        'name' : '',
        'gender' : 1,
        age : 0,
        grade : 0
    },
    {
        'rule'  :  'Sponsored For Employee Only',
        'name' : '',
        'gender' : 0,
        'age' : 0,
        grade : 0
    },
    {
        'rule'  :  'Emp-Sponsored-Benf-Once-Sponsored-Gender',
        'name' : '',
        'gender' : 1,
        grade : 0,
        age : 0
    },  
];